var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcLogicGAppPortfolioSolid = function SvgIcLogicGAppPortfolioSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    fill: "none",
    viewBox: "0 0 30 30"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.3 16.1h-.9c-2.9 0-5.3-2.4-5.2-5.4 0-2.9 2.4-5.2 5.2-5.2h.9c2.9 0 5.3 2.3 5.4 5.2 0 2.9-2.3 5.3-5.2 5.4zM23.6 27.3H6.7c-.4 0-.8-.4-.8-.8v-3.4c0-3.3 2.6-5.9 5.9-5.9h6.7c3.3 0 5.9 2.6 5.9 5.9v3.4c0 .4-.4.8-.8.8"
  })));
};
export default SvgIcLogicGAppPortfolioSolid;